import React from "react";
import styles from "./styles.module.css";

function StatsCard({ user }){
    console.log('StatsCard: ', user);
    
    const invoicesCount = user?.invoicesCount || 0;
    const plan = user?.plan || "free";
    const invoicesWeekStart = user?.invoicesWeekStart ? new Date(user.invoicesWeekStart) : null;
    

    // Retorna o domingo da semana atual (início da semana)
    const getStartOfWeek = (date) => {
        const d = new Date(date);
        const day = d.getDay();

        d.setHours(0,0,0,0);
        d.setDate(d.getDate() - day);

        return d;
    };
    // Verifica se estamos em uma nova semana
    const isNewWeek = () => {
        if (!invoicesWeekStart) return true;
        const startOfCurrentWeek = getStartOfWeek(new Date());
        const startOfUserWeek = getStartOfWeek(invoicesWeekStart);
        return startOfUserWeek.getTime() !== startOfCurrentWeek.getTime();
    }
    // Se for nova semana, reseta contagem visual
    const currentInvoicesCount = isNewWeek() ? 0 : invoicesCount;
    console.log("isNewWeek:", isNewWeek());
    console.log("currentInvoicesCount:", currentInvoicesCount);
    const getProgressWidth = () => {
        if(plan === "premium") return "100%";
        const limit = plan === "plus" ? 5 : 1;

        const progress = Math.min(100, (currentInvoicesCount / limit) * 100);

        return `${progress}%`;
    }

    const getLimit = () => {
        if(plan === "premium") return "∞";
        return plan === "plus" ? "5" : "1";
    }

    const getRemaining = () => {
        if(plan === "premium") return "∞";
        const limit = plan === "plus" ? 5 : 1;
        return Math.max(0, limit - currentInvoicesCount);
        //return invoicesCount;
    }

    const getPlanInfo = (plan) => {
        const plans = {
            free: { name: "Gratuito", limit: "1 nota por semana", color: styles.free },
            plus: { name: "Plus", limit: "5 notas por semana", color: styles.plus },
            premium: { name: "Premium", limit: "Ilimitado", color: styles.premium }
        };
        return plans[plan] || plans.free;        
    }
    //console.log('planInfo: ', user?.plan);
    const planInfo = getPlanInfo(plan);

    return (
        <div className={styles.statsCard}>
            <h3 className={styles.title}>Estatísticas da Semana</h3>

            <div className={styles.grid}>
                {/* Notas criadas */}
                <div className={`${styles.card} ${styles.indigo}`}>
                    <div className={styles.value}>{currentInvoicesCount}</div>
                    <div className={styles.label}>Notas criada</div>
                    <div className={styles.progressBar}>
                        <div className={styles.progresFill} style={{ width: getProgressWidth() }}></div>
                    </div>
                </div>
                {/* Limite semanal  */}
                <div className={`${styles.card} ${styles.green}`}>
                    <div className={styles.value}>{getLimit()}</div>
                    <div className={styles.label}>Limite semanal</div>
                    <div className={`${styles.badge} ${
                        plan === 'free'
                        ? styles.badgeBlue
                        : plan === 'plus'
                        ? styles.badgeGreen
                        : styles.badgePurple
                    }`}>
                        Plano {planInfo?.name}
                    </div>
                </div>
                {/* Disponíveis */}
                <div className={`${styles.card} ${styles.green}`}>
                    <div className={styles.value}>{getRemaining()}</div>
                    <div className={styles.label}>Disponíveis</div>
                    {plan !== 'premium' && getRemaining() === 0 && (
                        <div className={styles.limitText}>Limite atingido</div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default StatsCard;